package com.siriusxm.pia.operations

import com.siriusxm.cmc.CMCContainer
import com.siriusxm.mce.auth.browser.sxmServiceClient
import com.siriusxm.unifiedcontent.cmc.CMCService

/**
 * Extension function to create a configured CMCService client for operations API calls.
 *
 * The CMC service provides access to operational data including:
 * - queryLogs() - Query DataDog logs with filters for service, workload, region, environment
 * - getMonitors() - Get monitors by tag
 *
 * @return A CMCService client configured with authentication
 * @throws IllegalStateException if cmcApiUrl is not configured
 */
fun CMCContainer.cmcServiceClient(): CMCService {
    val url = configProperty("cmcApiUrl")
        ?: error("cmcApiUrl not configured in Configuration")
    return CMCService(url, sxmServiceClient())
}

/**
 * Parses DataDog log tags from colon-separated format into a Map.
 *
 * DataDog tags are formatted as "key:value" (e.g., "service:content-aggregator", "env:prod").
 * This utility extracts them into a Map for easier access.
 *
 * @param tags List of tag strings in "key:value" format
 * @return Map of tag keys to values
 */
fun parseLogTags(tags: List<String>?): Map<String, String> {
    return tags?.mapNotNull { tag ->
        val parts = tag.split(":", limit = 2)
        if (parts.size == 2) {
            parts[0] to parts[1]
        } else {
            null
        }
    }?.toMap() ?: emptyMap()
}
